import produce from "immer";
import { IStoreState } from "../../initialStoreState";

import { LoadState } from "../../../constants/enums";
import { initialBalanceSheetStatementState } from "./BalanceSheetStatements.types";
import { BalanceSheetStatementActions } from ".";
import { CLEAR_BALANCE_SHEET_STATEMENTS, FETCH_BALANCE_SHEET_STATEMENTS_LIST_FAILED, FETCH_BALANCE_SHEET_STATEMENTS_LIST_PROGRESS, FETCH_BALANCE_SHEET_STATEMENTS_LIST_SUCCESS } from "./BalanceSheetStatementActions";

export const balanceSheetStatementsReducer = (
  state: IStoreState["accounting"]["balancesheetStatements"] = initialBalanceSheetStatementState,
  action: BalanceSheetStatementActions
) => {
  switch (action.type) {
    case FETCH_BALANCE_SHEET_STATEMENTS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_BALANCE_SHEET_STATEMENTS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_BALANCE_SHEET_STATEMENTS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }

    case CLEAR_BALANCE_SHEET_STATEMENTS: {
      return initialBalanceSheetStatementState;
    }

    default: {
      return state;
    }
  }
};
